/**
 * @class
 */
import Base from '@netx/core/lib/netx-model';

import {systemFacetOptions} from '../properties/search';

export default class SearchFacetOption extends Base {
	/**
	 * @type {Netx.Rpc}
	 * @private
	 */
	get rpc() {
		return true;
	}

	/** @type {string} */
	get idAttribute() {
		return 'value';
	}

	/**
	 * @property {object}  defaults             - The default attribute values
	 * @property {number}  defaults.count       - Option asset match
	 * @property {boolean} defaults.selected    - Option selected
	 * @property {string}  defaults.value       - Option value (an attribute value)
	 * @property {string}  defaults.facetId     - Facet id
	 * @property {string}  defaults.facetLabel  - Facet label
	 */
	get defaults() {
		return {
			count: 0,
			selected: false,
			value: '',
			facetId: 0,
			facetLabel: '',
		};
	}

	/**
	 * @method
	 * @param {object} attr Model attributes
	 * @param {object} opts Model options
	 */
	constructor(attrs, opts) {
		super(attrs, opts);

		// Hey, listen!
		this.listenTo(dispatcher, 'search:facet:option:toggle', (model) => {
			// Only if it concerns us
			// And it concerns us if both value and facetId match
			// As well as matching parent collections
			if (
				(!model.collection ||
					model.collection._listenId === this.collection._listenId) &&
				model.get('facetId') === this.get('facetId') &&
				model.get('value') === this.get('value')
			) {
				this.toggle();
			}
		});

		// Set human readable title
		const value = this.get('value');
		const systemValue = systemFacetOptions[value];
		this.attributes.title = systemValue || value;
	}
	/**
	 * @method
	 * @param {boolean} state State
	 */
	toggle(state) {
		// Current state
		const selected = this.get('selected');
		// New state
		const newstate = !_.isUndefined(state) ? state : !selected;
		// If changed
		newstate != selected && this.set('selected', newstate);
	}

	/** @type {string} */
	static get __name__() {
		return 'SearchFacetOption';
	}
}
